import { AbstractPayTableProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractPayTableProperties";
import { deepEquals } from "../../../utils/deepEquals";
/**
 * Game-specific properties for the pay table.
 */
export class GamePayTableProperties extends AbstractPayTableProperties {
    equals(other) {
        return deepEquals(other, this);
    }
}
//# sourceMappingURL=GamePayTableProperties.js.map